import React, { useState } from 'react';
import './feedBackDetails.scss';
import '../../globals/scss/font.scss';
import Cookies from 'universal-cookie';
import { Box, Grid, Rating, Stack } from '@mui/material';
import DateRangePicker from '../TP_DateRangePicker';
import Dropdown from '../../components/TP_Dropdown';
import FeedBackFilter from '../FeedBackFilter';
import FeedBackGrid from '../FeedBackGrid';
import Button from '../common/Button';

const FeedBackDetails = () => {
	const [showFilter, setShowFilter] = useState(false);
	const [allTC, setAllTC] = useState([]);

	const cookies = new Cookies();
	const loginData = cookies.get('loginData');
	let userID = loginData?.id;
	let userRole = loginData?.role_code;
	let userStudioID = loginData?.studio_id;

	const datefilter = async (range) => {
		let startDate = range[0];
		let endDate = range[1];
		// let params = queryParamas;
		// console.log('startDate', startDate);
		// console.log('endDate', endDate);
		// range[0]
		// 	? (params.from_date = `${moment(startDate).format('YYYY-MM-DD')}`)
		// 	: delete params.from_date;

		// range[1]
		// 	? (params.end_date = `${moment(endDate).format('YYYY-MM-DD')}`)
		// 	: delete params.end_date;
		// setqueryParamas({ ...params });
		// console.log('datefilter', queryParamas);
	};

	let uniqueName = [
		//...new Map(studioName?.map((item) => [item['value'], item])).values(),
	];

	const dropdownSelectInstructor = (StudioName) => {
		// console.log('searchStudio', StudioName);
		// let params = queryParamas;
		// StudioName?.value
		// 	? (params.name = `${StudioName?.value}`)
		// 	: delete params.name;
		// setqueryParamas({ ...params });
	};

	const dropdownSelect = (getName) => {
		console.log('trainingCenter', getName);
		// let params = queryParamas;
		// getName?.id
		// 	? (params.studio_id = `${getName?.id}`)
		// 	: delete params.studio_id;
		// console.log('params', params);
		// setqueryParamas({ ...params });
	};

	const clearButton = () => {
		if (userRole == 'SUPER_ADMIN') {
			document.getElementById('TCFeedbackFilter').click();
		}
		document.getElementById('InstructorFeedbackFilter').click();
		document.getElementById('FeedBackCLearDate').click();
		setShowFilter(!showFilter);
	};

	return (
		<>
			<Box className="feedback_details_container">
				<FeedBackFilter />
				<div style={{ display: showFilter ? 'contents' : 'none' }}>
					<Stack
						direction="row"
						className="lowerFilterContain"
						justifyContent={'space-around'}
						marginTop="1%"
					>
						<Grid container>
							<Grid item flexGrow={0.2} xs={12} sm={12} md={5} lg={4}>
								<DateRangePicker
									getdateRange={datefilter}
									clearID={'FeedBackCLearDate'}
								/>
							</Grid>
							<Grid item flexGrow={0.2} xs={6} sm={6} md={2} lg={3}>
								<Dropdown
									clearable
									// value={options[0]}
									selection
									options={uniqueName}
									placeholder="Instructor"
									selectDropDown={dropdownSelectInstructor}
									clearID={'InstructorFeedbackFilter'}
								/>
							</Grid>
							{userRole === 'SUPER_ADMIN' ? (
								<Grid
									item
									flexGrow={0.3}
									xs={6}
									sm={6}
									md={3}
									lg={3}
									marginTop={{ xs: '1%', sm: '1%', md: '2%' }}
								>
									<Dropdown
										clearable
										placeholder="Training Center"
										options={allTC}
										selectDropDown={dropdownSelect}
										clearID={'TCFeedbackFilter'}
										sx={{ borderRight: '2px solid #2C2C2C ', height: '40px' }}
									/>
								</Grid>
							) : (
								''
							)}
							<Grid
								item
								xs={12}
								sm={12}
								md={2}
								lg={2}
								className="marginTopInstrut"
							>
								<Button
									className="fs-4"
									value="Clear Filter"
									role="clearFilter"
									onClick={() => {
										clearButton();
									}}
								>
									Clear Filter
								</Button>
							</Grid>
						</Grid>
					</Stack>
				</div>
			</Box>
			<Box className="feedback_details_container">
				<Grid container columnSpacing={2} rowSpacing={2}>
					<Grid item xs={12} sm={12} md={12} lg={8}>
						<Box className="FeedBack_details">
							<Box className="FeedBack_details_listing">
								<Box className="FeedBack_details_listing_trainerName large_f_bold">
									Training Name - Arjun Kori
								</Box>
								<Box className="feedback_details_listing_box">
									<Grid container rowSpacing={4}>
										<Grid item xs={12} sm={12} md={12} lg={12}>
											<Grid
												container
												className="FeedBack_details_listing_container"
												direction="row"
												justifyContent="center"
												alignItems="center"
											>
												<Grid
													item
													xs={12}
													sm={6}
													md={4}
													lg={4}
													className="FeedBack_details_listing_rt_border"
													direction="row"
													justifyContent="center"
													alignItems="end"
												>
													<Grid
														container
														className="FeedBack_details_listing_checkbox medium_f"
													>
														<Box className="align medium_f">
															<input
																type="checkbox"
																className="checkbox_rt_margin"
															/>
															Student FeedBack_details_listing_trainerName
														</Box>
													</Grid>
												</Grid>
												<Grid
													item
													xs={12}
													sm={6}
													md={4}
													lg={3}
													className="FeedBack_details_listing_date FeedBack_details_listing_rt_border medium_f"
												>
													<Box>
														<span>9th september 2022</span>
													</Box>
												</Grid>
												<Grid
													itme
													xs={12}
													sm={6}
													md={4}
													lg={3}
													className="medium_f FeedBack_details_listing_rt_border"
												>
													<Box>
														<span className="FeedBack_details_listing_rating">
															Rating :
														</span>
														<span>
															<Rating
																name="size-small"
																defaultValue={5}
																readOnly
																size="small"
															/>
														</span>
													</Box>
												</Grid>
												<Grid
													xs={12}
													sm={6}
													md={4}
													lg={2}
													item
													className="medium_f"
												>
													<Box>
														<span className="FeedBack_details_listing_status">
															completed
														</span>
													</Box>
												</Grid>
											</Grid>
										</Grid>
										<Grid item xs={12} sm={12} md={12} lg={12}>
											<Grid
												container
												className="FeedBack_details_listing_container"
												direction="row"
												justifyContent="center"
												alignItems="center"
											>
												<Grid
													item
													xs={12}
													sm={6}
													md={4}
													lg={4}
													className="FeedBack_details_listing_rt_border"
													direction="row"
													justifyContent="center"
													alignItems="end"
												>
													<Grid
														container
														className="FeedBack_details_listing_checkbox medium_f"
													>
														<Box className="align">
															<input
																type="checkbox"
																className="checkbox_rt_margin"
															/>
															Student Namejknlknkllnkll
														</Box>
													</Grid>
												</Grid>
												<Grid
													item
													xs={12}
													sm={6}
													md={4}
													lg={3}
													className="FeedBack_details_listing_date FeedBack_details_listing_rt_border medium_f"
												>
													<Box>
														<span>9th september 2022</span>
													</Box>
												</Grid>
												<Grid
													itme
													xs={12}
													sm={6}
													md={4}
													lg={3}
													className="medium_f FeedBack_details_listing_rt_border"
												>
													<Box>
														<span className="FeedBack_details_listing_rating">
															Rating :
														</span>
														<span>
															<Rating
																name="size-small"
																defaultValue={5}
																readOnly
																size="small"
															/>
														</span>
													</Box>
												</Grid>
												<Grid
													xs={12}
													sm={6}
													md={4}
													lg={2}
													item
													className="medium_f"
												>
													<Box>
														<span className="FeedBack_details_listing_status">
															completed
														</span>
													</Box>
												</Grid>
											</Grid>
										</Grid>
										<Grid item xs={12} sm={12} md={12} lg={12}>
											<Grid
												container
												className="FeedBack_details_listing_container"
												direction="row"
												justifyContent="center"
												alignItems="center"
											>
												<Grid
													item
													xs={12}
													sm={6}
													md={4}
													lg={4}
													className="FeedBack_details_listing_rt_border"
													direction="row"
													justifyContent="center"
													alignItems="end"
												>
													<Grid
														container
														className="FeedBack_details_listing_checkbox medium_f"
													>
														<Box className="align">
															<input
																type="checkbox"
																className="checkbox_rt_margin"
															/>
															Student Namejknlknkllnkll
														</Box>
													</Grid>
												</Grid>
												<Grid
													item
													xs={12}
													sm={6}
													md={4}
													lg={3}
													className="FeedBack_details_listing_date FeedBack_details_listing_rt_border medium_f"
												>
													<Box>
														<span>9th september 2022</span>
													</Box>
												</Grid>
												<Grid
													itme
													xs={12}
													sm={6}
													md={4}
													lg={3}
													className="medium_f FeedBack_details_listing_rt_border"
												>
													<Box>
														<span className="FeedBack_details_listing_rating">
															Rating :
														</span>
														<span>
															<Rating
																name="size-small"
																defaultValue={5}
																readOnly
																size="small"
															/>
														</span>
													</Box>
												</Grid>
												<Grid
													xs={12}
													sm={6}
													md={4}
													lg={2}
													item
													className="medium_f"
												>
													<Box>
														<span className="FeedBack_details_listing_status">
															completed
														</span>
													</Box>
												</Grid>
											</Grid>
										</Grid>
										<Grid item xs={12} sm={12} md={12} lg={12}>
											<Grid
												container
												className="FeedBack_details_listing_container"
												direction="row"
												justifyContent="center"
												alignItems="center"
											>
												<Grid
													item
													xs={12}
													sm={6}
													md={4}
													lg={4}
													className="FeedBack_details_listing_rt_border"
													direction="row"
													justifyContent="center"
													alignItems="end"
												>
													<Grid
														container
														className="FeedBack_details_listing_checkbox medium_f"
													>
														<Box className="align">
															<input
																type="checkbox"
																className="checkbox_rt_margin"
															/>
															Student Name
														</Box>
													</Grid>
												</Grid>
												<Grid
													item
													xs={12}
													sm={6}
													md={4}
													lg={3}
													className="FeedBack_details_listing_date FeedBack_details_listing_rt_border medium_f"
												>
													<Box>
														<span>9th september 2022</span>
													</Box>
												</Grid>
												<Grid
													itme
													xs={12}
													sm={6}
													md={4}
													lg={3}
													className="medium_f FeedBack_details_listing_rt_border"
												>
													<Box>
														<span className="FeedBack_details_listing_rating">
															Rating :
														</span>
														<span>
															<Rating
																name="size-small"
																defaultValue={5}
																readOnly
																size="small"
															/>
														</span>
													</Box>
												</Grid>
												<Grid
													xs={12}
													sm={6}
													md={4}
													lg={2}
													item
													className="medium_f"
												>
													<Box>
														<span className="FeedBack_details_listing_status">
															completed
														</span>
													</Box>
												</Grid>
											</Grid>
										</Grid>
										<Grid item xs={12} sm={12} md={12} lg={12}>
											<Grid
												container
												className="FeedBack_details_listing_container"
												direction="row"
												justifyContent="center"
												alignItems="center"
											>
												<Grid
													item
													xs={12}
													sm={6}
													md={4}
													lg={4}
													className="FeedBack_details_listing_rt_border"
													direction="row"
													justifyContent="center"
													alignItems="end"
												>
													<Grid
														container
														className="FeedBack_details_listing_checkbox medium_f"
													>
														<Box className="align">
															<input
																type="checkbox"
																className="checkbox_rt_margin"
															/>
															Student Namejknlknkllnkll
														</Box>
													</Grid>
												</Grid>
												<Grid
													item
													xs={12}
													sm={6}
													md={4}
													lg={3}
													className="FeedBack_details_listing_date FeedBack_details_listing_rt_border medium_f"
												>
													<Box>
														<span>9th september 2022</span>
													</Box>
												</Grid>
												<Grid
													itme
													xs={12}
													sm={6}
													md={4}
													lg={3}
													className="medium_f FeedBack_details_listing_rt_border"
												>
													<Box>
														<span className="FeedBack_details_listing_rating">
															Rating :
														</span>
														<span>
															<Rating
																name="size-small"
																defaultValue={5}
																readOnly
																size="small"
															/>
														</span>
													</Box>
												</Grid>
												<Grid
													xs={12}
													sm={6}
													md={4}
													lg={2}
													item
													className="medium_f"
												>
													<Box>
														<span className="FeedBack_details_listing_status">
															completed
														</span>
													</Box>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Box>
							</Box>
						</Box>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={4}>
						<Box className="FeedBack_details">
							<Grid container xs={12} rowSpacing={2}>
								<Grid item xs={12} sm={6} md={6} lg={12}>
									<FeedBackGrid />
								</Grid>
								<Grid item xs={12} sm={6} md={6} lg={12}>
									<FeedBackGrid />
								</Grid>
								<Grid item xs={12} sm={6} md={6} lg={12}>
									<FeedBackGrid />
								</Grid>
								<Grid item xs={12} sm={6} md={6} lg={12}>
									<FeedBackGrid />
								</Grid>
								<Grid item xs={12} sm={6} md={6} lg={12}>
									<FeedBackGrid />
								</Grid>
							</Grid>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};

export default FeedBackDetails;
